// extracted by mini-css-extract-plugin
export var buttonWithLink = "choice-of-golang-module--button-with-link--vq7se";
export var descriptionContainer = "choice-of-golang-module--description-container--m35PU";
export var firstRow = "choice-of-golang-module--first-row--vSen4";
export var imageContainer = "choice-of-golang-module--image-container--tCJJa";
export var regularFont = "choice-of-golang-module--regular-font--NK2-b";